<template>
    <NuxtLink
        :to="$withLocalePrefix('/')"
        :class="{'navbar__logo--hidden': !isVisible}"
        :external="isExternalLink"
        data-testid="navbar-logo-link"
        class="navbar__logo"
        @click="$emit('closeMenu')"
    >
        <MaltImg src="/cms-front/maltLogo.png" alt="Malt Logo" height="32" />
    </NuxtLink>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {MaltImg, NuxtLink} from '#components';
    import {useRoute} from '#imports';

    defineProps<{
        isVisible: boolean;
    }>();

    defineEmits<{
        closeMenu: [];
    }>();

    const route = useRoute();
    const isExternalLink = computed(() => route.path !== '/');
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .navbar__logo {
        position: relative;
        bottom: 14px;
        opacity: 1;
        transform: translate3d(0, 0, 0);
        transition:
            opacity calc(var(--navbar-transition-duration) * 0.4) var(--navbar-transition-easing) calc(var(--navbar-transition-duration) * 0.6),
            transform var(--navbar-transition-duration) var(--navbar-transition-easing);
        will-change: transform, opacity;
        backface-visibility: hidden;
        display: block;
        flex-shrink: 0;

        img {
            height: 32px;
            display: block;
        }

        &--hidden {
            opacity: 0;
            transform: translate3d(-20px, 0, 0);
            pointer-events: none;
            transition-delay: 0s, 0s;
        }

        @include mq.screen_md(min) {
            transform: none;
            opacity: 1;
        }
    }
</style>
